// extracted by mini-css-extract-plugin
export default {"container":"credentials_container__FF16w","section":"credentials_section__J-TYQ"};